// assets/mwc-register.js

(function () {
  if (window.mwcRegisterInitialized) return;
  window.mwcRegisterInitialized = true;

function getRegisterDomain() {
  return "https://mwc-register-account.patrickwjmans.workers.dev";
}

function getAuthDomain() {
  return "https://auth.watchopedia.watch";
}

  function getEdgeDomain() {
    return "https://edge." + window.location.host;
  }

  function getRedirectUrl() {
    return window.location.origin + "/pages/mwc";
  }

  function getEmailEl() {
    return document.getElementById("mwc-register-email");
  }

  function getConfirmEmailEl() {
    return document.getElementById("mwc-register-email-confirm");
  }

  function getPasswordEl() {
    return document.getElementById("mwc-register-password");
  }

function getFirstNameEl() {
  return document.getElementById("mwc-register-first-name");
}

function getLastNameEl() {
  return document.getElementById("mwc-register-last-name");
}

function getCityEl() {
  return document.getElementById("mwc-register-city");
}

function getCountryEl() {
  return document.getElementById("mwc-register-country");
}

  function getSubmitEl() {
    return document.getElementById("mwc-register-submit");
  }

  function getServerMessageEl() {
    return document.getElementById("mwc-register-server-message");
  }

  function getErrorEl(key) {
    return document.getElementById("mwc-register-" + key + "-error");
  }

  function setFieldError(key, message) {
    var el = getErrorEl(key);
    if (!el) return;
    el.textContent = message || "";
    el.style.display = message ? "block" : "none";
  }

  function clearFieldErrors() {
    setFieldError("email", "");
    setFieldError("email-confirm", "");
    setFieldError("password", "");
  }

  function setServerMessage(message) {
    var el = getServerMessageEl();
    if (!el) return;
    el.textContent = message || "";
    el.style.display = message ? "block" : "none";
  }

  function clearServerMessage() {
    setServerMessage("");
  }

  function setLoading(loading) {
    var button = getSubmitEl();
    var email = getEmailEl();
    var confirmEmail = getConfirmEmailEl();
    var password = getPasswordEl();

    if (button) {
      button.disabled = !!loading;
      button.textContent = loading ? "Creating account..." : "Create account";
    }

    if (email) email.disabled = !!loading;
    if (confirmEmail) confirmEmail.disabled = !!loading;
    if (password) password.disabled = !!loading;
  }

  function normalizeEmail(value) {
    return String(value || "").trim().toLowerCase();
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function validate() {
    clearFieldErrors();
    clearServerMessage();

    var email = normalizeEmail(getEmailEl() && getEmailEl().value);
    var confirmEmail = normalizeEmail(getConfirmEmailEl() && getConfirmEmailEl().value);
    var password = String(getPasswordEl() && getPasswordEl().value || "");

    var firstName = String(
  (getFirstNameEl() && getFirstNameEl().value) || ""
).trim();

var lastName = String(
  (getLastNameEl() && getLastNameEl().value) || ""
).trim();

var city = String(
  (getCityEl() && getCityEl().value) || ""
).trim();

var country = String(
  (getCountryEl() && getCountryEl().value) || ""
).trim();

    var valid = true;

    if (!email) {
      setFieldError("email", "Email is required.");
      valid = false;
    } else if (!isValidEmail(email)) {
      setFieldError("email", "Enter a valid email address.");
      valid = false;
    }

    if (!confirmEmail) {
      setFieldError("email-confirm", "Please confirm your email address.");
      valid = false;
    } else if (confirmEmail !== email) {
      setFieldError("email-confirm", "Email addresses must match.");
      valid = false;
    }

    if (!password) {
      setFieldError("password", "Password is required.");
      valid = false;
    } else if (password.length < 6) {
      setFieldError("password", "Password must be at least 6 characters.");
      valid = false;
    }

    return {
      valid: valid,
      email: email,
      password: password,

    // ✅ meegeven maar NIET verplicht
    first_name: firstName || null,
    last_name: lastName || null,
    city: city || null,
    country: country || null

    };
  }

  async function readText(res) {
    try {
      return await res.text();
    } catch (e) {
      return "";
    }
  }

  function mapRegisterError(message) {
    var text = String(message || "").toLowerCase();

    if (text === "email already exists") {
      return "This email address has already registered. Please log in instead.";
    }

    if (text === "invalid email") {
      return "Enter a valid email address.";
    }

    if (text === "password too short") {
      return "Password must be at least 6 characters.";
    }

    if (text === "email and password required") {
      return "Email and password are required.";
    }

    return "Could not create account. Please try again.";
  }

  function buildHiddenInput(name, value) {
  var input = document.createElement("input");
  input.type = "hidden";
  input.name = name;
  input.value = value;
  return input;
}

function loginAndContinue(email, password) {
  var form = document.createElement("form");
  form.method = "POST";
  form.action = getAuthDomain() + "/login";
  form.style.display = "none";

  form.appendChild(buildHiddenInput("email", email));
  form.appendChild(buildHiddenInput("password", password));
  form.appendChild(buildHiddenInput("store", getEdgeDomain()));
  form.appendChild(buildHiddenInput("redirect", getRedirectUrl()));

  document.body.appendChild(form);
  form.submit();
}

  async function submitRegister() {
    var state = validate();

    if (!state.valid) {
      return;
    }

    try {
      setLoading(true);

      var createRes = await fetch(getRegisterDomain() + "/create-user", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify({
          email: state.email,
          password: state.password,

              // ✅ optioneel meesturen
    first_name: state.first_name,
    last_name: state.last_name,
    city: state.city,
    country: state.country
        })
      });

      if (!createRes.ok) {
        var createText = await readText(createRes);

        if (String(createText || "").toLowerCase() === "invalid email") {
          setFieldError("email", "Enter a valid email address.");
        } else if (String(createText || "").toLowerCase() === "password too short") {
          setFieldError("password", "Password must be at least 6 characters.");
        } else if (String(createText || "").toLowerCase() === "email already exists") {
          setFieldError("email", "This email address has already registered. Please log in instead.");
        } else {
          setServerMessage(mapRegisterError(createText));
        }

        return;
      }

var formWrapper = document.querySelector(".mwc-auth-login");
if (formWrapper) {
window.mwcRegisteredEmail = state.email;
formWrapper.innerHTML = `
  <div style="padding:24px;text-align:center;">
    <h1 style="margin-bottom:12px;">Check your email</h1>
    <!-- <p style="font-size:14px;color:#666;margin-bottom:16px;"> -->
      <p>Thank you for registering.<br/>
      We’ve sent you a verification email. You should receive this in the next 2 minutes.<br/><br/>
      Please click the link in that email to activate your account.
    </p><br><br>
    <p>You did not receive an email? Click the resend button below.</p>

    <button id="mwc-resend-verification" class="button button--outline" type="button">
      Resend verification email
    </button>

    <div id="mwc-resend-status" style="margin-top:12px;font-size:12px;color:#666;"></div>
  </div>
`;
}
    } catch (e) {
      setServerMessage(e && e.message ? mapRegisterError(e.message) : "Could not create account. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  document.addEventListener("click", function (event) {
    var button = event.target.closest("#mwc-register-submit");
    if (!button) return;
    submitRegister();
  });

  document.addEventListener("keydown", function (event) {
    var isRegisterField =
      event.target &&
      (
        event.target.id === "mwc-register-email" ||
        event.target.id === "mwc-register-email-confirm" ||
        event.target.id === "mwc-register-password"
      );

    if (isRegisterField && event.key === "Enter") {
      event.preventDefault();
      submitRegister();
    }
  });

  document.addEventListener("input", function (event) {
    if (!event.target) return;

    if (event.target.id === "mwc-register-email") {
      setFieldError("email", "");
      setFieldError("email-confirm", "");
      clearServerMessage();
    }

    if (event.target.id === "mwc-register-email-confirm") {
      setFieldError("email-confirm", "");
      clearServerMessage();
    }

    if (event.target.id === "mwc-register-password") {
      setFieldError("password", "");
      clearServerMessage();
    }
  });

  document.addEventListener("click", async function (e) {
  var btn = e.target.closest("#mwc-resend-verification");
  if (!btn) return;

  var status = document.getElementById("mwc-resend-status");
  if (status) status.textContent = "Sending...";

  try {
    var email = window.mwcRegisteredEmail;

    await fetch(getRegisterDomain() + "/resend-verification", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ email: email })
    });

    if (status) {
      status.textContent = "Verification email sent.";
    }
  } catch (e) {
    if (status) {
      status.textContent = "Could not resend email.";
    }
  }
});
})();